import React from 'react';
import {
  AlertCircle,
  AlertTriangle,
  Shield,
  CheckCircle,
  XCircle,
  MessageCircle,
  MessageSquare,
  DollarSign,
  Scale,
  Clock,
  FileText,
  Bell,
  Briefcase,
  Calculator,
  Calendar,
  Eye,
  Flag,
  Zap,
  Target,
  TrendingUp,
  TrendingDown,
  Users,
  Building,
  Globe,
  Lock,
  Key,
  Settings,
  Info,
  HelpCircle,
  ChevronRight,
  ChevronDown,
  Plus,
  Minus,
  Edit,
  Trash2,
  Download,
  Upload,
  Search,
  Filter,
  Tag,
  Bookmark
} from 'lucide-react';

interface DynamicIconProps {
  name: string;
  className?: string;
  size?: number;
}

// Icon mapping object
const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'shield': Shield,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  'dollar-sign': DollarSign,
  'scale': Scale,
  'clock': Clock,
  'file-text': FileText,
  'bell': Bell,
  'briefcase': Briefcase,
  'calculator': Calculator,
  'calendar': Calendar,
  'eye': Eye,
  'flag': Flag,
  'zap': Zap,
  'target': Target,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'users': Users,
  'building': Building,
  'globe': Globe,
  'lock': Lock,
  'key': Key,
  'settings': Settings,
  'info': Info,
  'help-circle': HelpCircle,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  'plus': Plus,
  'minus': Minus,
  'edit': Edit,
  'trash-2': Trash2,
  'download': Download,
  'upload': Upload,
  'search': Search,
  'filter': Filter,
  'tag': Tag,
  'bookmark': Bookmark
};

const DynamicIcon: React.FC<DynamicIconProps> = ({ name, className = 'w-5 h-5', size }) => {
  // Get the icon component from the map
  const IconComponent = iconMap[name];

  // If icon not found, show a default icon
  if (!IconComponent) {
    return <AlertCircle className={size ? `w-${size} h-${size}` : className} />;
  }

  return <IconComponent className={size ? `w-${size} h-${size}` : className} />;
};

export default DynamicIcon;